import { createSlice } from "@reduxjs/toolkit";
import { getCurrenciesNameAction, getTickersAction } from "../../../actions";
import { CHART_PATTERN } from "../../../constant/common";

const initialState = {
  settings: /** @type { import("../../..").CompanySetting } */({}),
  external: /** @type { import("../../..").CompanyExternalSetting } */({
    tickerPattern: {},
    colorBlindMode: false,
    enableColorBlindMode: false,
    currenciesName: {}
  }) // use as custom settings
};
const settingSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setSettings: (state, { payload }) => {
      const settings = /** @type { import("../../..").CompanySetting } */(payload)
      state.settings = payload;
      state.external.tickerPattern = [...settings.instruments, ...settings.peers].reduce((acc, item, index) => {
        acc[item.id] = CHART_PATTERN[index > (CHART_PATTERN.length - 1) ? CHART_PATTERN.length - 1 : index];
        return acc;
      }, {})
      state.external.enableColorBlindMode = Boolean(settings.enabledColorBlindMode)
      state.external.colorBlindMode = false;
    },
    setColorBlind: (state, /** @type {{payload: boolean}} */{ payload }) => {
      state.external.colorBlindMode = payload
    }
  },
  extraReducers: builder => builder
  .addCase(getCurrenciesNameAction.fulfilled, (state, {payload}) => {
    state.external.currenciesName = payload.data.currency.currenciesByCodes.reduce((acc, item) => {
      if(!(item.code in acc)) acc[item.code] = item.name
      return acc;
    }, state.external.currenciesName)
  })
  .addCase(getTickersAction.fulfilled, (state, {payload}) => {
    state.external.currenciesName = payload.data.instruments.reduce((acc, item) => {
      if(!(item.currencyCode in acc)) acc[item.currencyCode] = item.currency
      return acc;
    }, state.external.currenciesName);
  })
});

export default settingSlice;

export const { setSettings, setColorBlind } = settingSlice.actions;
